import { useQuery } from "@tanstack/react-query";

import { API_URL } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { useUser } from "@/context/user-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { authHeader } from "@/utils/headers";

/**
 * List vector stores
 */
export const useVectorStores = (enabled = true) => {
  const auth = useAuth();
  const userContext = useUser();
  const workspaceId = userContext?.activeWorkspaceId;

  return useQuery({
    queryKey: ["vector-stores", workspaceId],
    queryFn: async () => {
      const response = await fetch(
        `${API_URL}/api/dashboard/v2/vector-store/list?workspace_id=${workspaceId}`,
        {
          headers: authHeader(auth!.userToken!),
        },
      ).then(handleResponse);

      // Check if response has success: false
      if (response && typeof response === "object" && "success" in response) {
        if (response.success === false) {
          const errorMessage =
            (response as { message?: string }).message || "Failed to fetch vector stores";
          throw new Error(errorMessage);
        }
      }

      return response;
    },
    enabled: !!workspaceId && enabled,
  });
};
